import React from 'react';
import { motion } from 'framer-motion';
export function BibliotecaSection() {
  const items = ['Recetario H.E.R.'];
  return <section className="bg-gradient-hero py-24 md:py-32 px-4 md:px-8" data-id="element-13">
      <div className="max-w-2xl mx-auto text-center" data-id="element-14">
        {/* Eyebrow */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="uppercase tracking-[0.3em] text-[#C8A870] font-semibold mb-6 text-[12px]" data-id="element-15">
          TU PRÓXIMO PASO
        </motion.p>

        {/* Title */}
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="font-display text-4xl md:text-6xl font-semibold leading-[1.08] text-[#F0E8D8]" data-id="element-16">
          Tu cuerpo está cambiando. Merece un enfoque diferente
        </motion.h2>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="mt-6 text-lg md:text-xl font-body text-foreground/70 leading-relaxed max-w-lg mx-auto" data-id="element-17">
          Empezá a entender qué necesita tu cuerpo en esta etapa.
        </motion.p>

        {/* Thin editorial divider */}
        <div className="divider-fine w-24 mx-auto my-12 md:my-14" data-id="element-18" />

        {/* Editorial list — no heavy cards, lots of negative space */}
        <ul className="max-w-md mx-auto" data-id="element-19">{items.map((item, i) => {})}</ul>
      </div>
    </section>;
}